/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import React from 'react';
import PropTypes from 'prop-types';

// components
import { Grid } from '@design-system-coopeuch/web';
import SimpleCard from '../../molecules/SimpleCard/SimpleCard';

// assets
import iconIdDoc from '../../../assets/img/icon-id-doc.svg';
import iconCamera from '../../../assets/img/icon-camera.svg';
import iconTurnOn from '../../../assets/img/icon-turnon.svg';

const CardIdentityValidation = (props) => {
  const { disabled } = props;

  return (
    <SimpleCard
      disabled={disabled}
      contentHeader={<p className="simplecard__title">Verificación de identidad</p>}
    >
      <Grid row className="m-0 padding-16 p-md-6 justify-content-around">
        <Grid className="p-0 d-flex mb-3" col={12}>
          <p className="font-size-14 line-height-22">Debes tener a mano:</p>
        </Grid>
        <Grid
          className="p-0 d-flex flex-column justify-content-start align-items-center"
          col={12}
          md={4}
        >
          <img src={iconCamera} alt="" width="48" height="48" className="" />
          <p className="font-size-16 line-height-22 font-weight-bold text-center px-4 mt-2">
            Celular con cámara
          </p>
          <p className="p-0 px-4 mt-2 text-center font-size-14 line-height-20">
            Para saber que eres tú, te pediremos una foto o selfie desde tu smartphone.
          </p>
        </Grid>
        <Grid
          className="p-0 d-flex flex-column justify-content-start align-items-center mt-2 mt-md-0"
          col={12}
          md={4}
        >
          <img src={iconIdDoc} alt="" width="48" height="48" className="" />
          <p className="font-size-16 line-height-22 font-weight-bold text-center px-4 mt-2">
            Cédula de identidad
          </p>
          <p className="p-0 px-4 mt-2 text-center font-size-14 line-height-20">
            Vigente y en buen estado. Debes sacarle una foto con tu celular.
          </p>
        </Grid>
        {/* <Grid
          className="p-0 d-flex flex-column justify-content-start align-items-center mt-2 mt-md-0"
          col={12}
          md={4}
        >
          <img src={iconTurnOn} alt="" width="48" height="48" className="" />
          <p className="font-size-16 line-height-22 font-weight-bold text-center px-4 mt-2">
            Clave Única
          </p>
          <p className="p-0 px-4 mt-2 text-center font-size-14 line-height-20">
            La que usas en el Registro Civil. Te haremos algunas preguntas.
          </p>
        </Grid> */}
      </Grid>
    </SimpleCard>
  );
};

CardIdentityValidation.defaultProps = {};

CardIdentityValidation.propTypes = {};

export default CardIdentityValidation;
